/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/chevron-down
 */
import { default as DefaultIcon } from '~icons/lucide/chevron-down';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ChevronDownIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
